import i18n from '../../../i18n';
import { arraySortAscendingFunction } from '../../utilities';

export const getBrkPropertiesData = (searchData, propertiesJson) => {
    let items = [];
    let fields = [];

    if (!propertiesJson) {
        return {
            items,
            fields
        };
    }

    for (let i = 0, l = propertiesJson.length; i < l; i++) {
        let adres = null;
        if (propertiesJson[i].adressen && propertiesJson[i].adressen.length > 0) {
            adres = `${propertiesJson[i]?.adressen[0]?.adresregel1}, ${propertiesJson[i]?.adressen[0]?.adresregel2}`;
        }
        items.push({
            id: i,
            nedGlobeRowId: i, // provide a unique ID column to avoid conflicts with the ID column in the data
            kadAanduiding: propertiesJson[i].kadastraleAanduiding,
            identificatie: propertiesJson[i].identificatie,
            adres: adres,
            location: propertiesJson[i].plaatscoordinaten.coordinates
        });
    }


    if (items.length > 0) {
        fields.push(
            {
                key: 'kadAanduiding',
                label: i18n.t('brk.cadastralDesignation'),
                sortable: true,
                showField: true
            },
            {
                key: 'identificatie',
                label: i18n.t('brk.numberDesignation'),
                sortable: true,
                showField: true
            },
            {
                key: 'adres',
                label: i18n.t('brk.searchCat4'),
                sortable: true,
                showField: true
            }

        );
    }

    // sort items
    items.sort(arraySortAscendingFunction('kadAanduiding'));

    return {
        items,
        fields: fields.filter(({ showField }) => showField),
        sortBy: 'kadAanduiding',
        selectable: true,
        relation: {
            name: i18n.t('brk.detailedInformation'),
            title: `${String(i18n.t('relations.showRelated'))} ${(String(i18n.t('brk.detailedInformation').toLowerCase()))}`,
            type: 'link',
            action: 'GetBrkDetailedInformation'
        }
    };

};
